import '../../../core/components/chart-grid/ChartGrid.css';
import './HistogramOverlays.css';
export var crosshairLayout = '_lbwgkq1-2-0-1 _2c3zgm0-2-0-1';
export var datapointLayout = '_lbwgkq0-2-0-1 _2c3zgm0-2-0-1';